document.addEventListener("click", function (e) {
  const btn = e.target.closest(".js-quick-add");
  if (!btn) return;

  // Safeguard: block clicks if button is disabled, has disabled attribute, or is already loading
  if (btn.disabled || btn.hasAttribute("disabled") || btn.classList.contains("btn--loading") || btn.classList.contains("disabled")) {
    e.preventDefault();
    return;
  }

  e.preventDefault();

  const variantId = btn.dataset.id;
  const button = btn;

  // Enable loading state
  button.disabled = true;
  button.classList.add("btn--loading");

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
    }),
  })
    .then((response) => response.json())
    .then(() => {
      document.dispatchEvent(new CustomEvent("cart:build"));
      document.dispatchEvent(new CustomEvent("cart:open"));

      button.classList.remove("btn--loading");
      button.innerText = "Added ✓";

      setTimeout(() => {
        button.innerText = "Quick Add";
        button.disabled = false;
      }, 1500);
    })
    .catch((error) => {
      console.error(error);
      button.classList.remove("btn--loading");
      button.innerText = "Error";
      button.disabled = false;
    });
});
